import React, { useEffect, useState } from "react";
import { Navigate, Outlet, Route, Routes, useLocation } from "react-router-dom";
import Footer from "components/footer/Footer";
import NormalHeader from "components/header/Normal/Header";
import UserHeader from "components/header/User/Header";
import Login from "pages/forms/Login";
import ResetPassword from "pages/forms/RestPassword";
import SignUp from "pages/forms/SignUp";

import Dashboard from "dashboard/user-dashboard/Dashbaord";

import EditProfile from "dashboard/edit-profile/EditProfile";
import UpdateUserProfile from "dashboard/edit-profile/UpdateUserProfile";
import UpdateKYCDetails from "dashboard/edit-profile/UpdateKYCDetails";
import Lecture from "dashboard/lecture/Lecture";
import TestSeries from "dashboard/test-series/TestSeries";
import { isLoggedIn } from "config/utils";
import LectureVideo from "dashboard/lecture/lecture-video/LectureVideo";
import TestPage from "dashboard/test-series/testPage/TestPage";
import TestResultSummery from "dashboard/test-series/testPage/TestResultSummery";
import LiveLectureVideo from "dashboard/liveLecture/LiveLectureVideo";
import OnDemandLectureDetail from "dashboard/lecture/on-demand/OnDemandLectureDetail";
import CourseReport from "dashboard/course-report/CourseReport";
import ReUploadAnswerSheet from "dashboard/reupload-answer-sheet/ReUploadAnswerSheet";
import PostalCourseSubListing from "dashboard/postal-course-document/PostalFile";
import PostalFolderList from "dashboard/postal-course-document/PostalFolder";
import LectureByNotesNew from "dashboard/lecture/Section/LectureByNotesNew";
import NewOurToppers from "dashboard/our-toppers/NewOurToppers";
import NewPostalFolderList from "dashboard/postal-course-document/NewPostalFolder";
import NewPostalFileListing from "dashboard/postal-course-document/NewPostalFile";
import WelcomeMentorshipPage from "dashboard/mentor-book-appointment/welcomementor/WelcomeMentorship";
import LectureLayout from "dashboard/lecture/PersonalizedLectures/PesonalizedLectureLayout";
import PersonalizedLectureVideo from "dashboard/lecture/PersonalizedLectures/PlayPersonalizedVideo/PersonalizedVideo";
import NotFound from "pages/not-found/NotFound";
import DailyQuiz from "pages/daily-quiz/DailyQuiz";
import TestUnit from "dashboard/test-series/test/TestUnit";

const ProtectedRoute = ({ children }) => {
  if (!isLoggedIn()) {
    return <Navigate to="/login" replace />;
  } else {
    return children;
  }
};

const NormalHeaderOutlet = () => {
  return (
    <>
      <div>
        <NormalHeader />
        <Outlet />
        {/* button for enquiry */}
        <Footer />
      </div>
    </>
  );
};

const WithoutHeader = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

const UserHeaderOutlet = ({ courseDrawerShow, setCourseDrawerShow }) => {
  return (
    <>
      <div>
        <UserHeader
          courseDrawerShow={courseDrawerShow}
          setCourseDrawerShow={setCourseDrawerShow}
        />
        <Outlet />
        {/* <Footer /> */}
      </div>
    </>
  );
};


const Routing = () => {
  const [courseDrawerShow, setCourseDrawerShow] = useState(false);
  const location = useLocation();
  const [centerflag, setcenterflag] = useState(false)
  useEffect(() => {
    if (location?.pathname.includes("IAS")) {
      setcenterflag(true);
    } else {
      setcenterflag(false);
    }
  }, [location]);
  return (
    <section className="routing">
      <Routes basename="/">
        {/* normal Header routes */}
        <Route path="/" element={<Login />} />
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<SignUp />} />
        <Route path="/reset-password/:token" element={<ResetPassword />} />




        {/* user header routes */}
        <Route
          exact
          path="/dashboard"
          element={
            <ProtectedRoute>
              <UserHeaderOutlet
                courseDrawerShow={courseDrawerShow}
                setCourseDrawerShow={setCourseDrawerShow}
              />
            </ProtectedRoute>
          }
        >




          <Route
            exact
            path="/dashboard/home"
            element={
              <ProtectedRoute>
                <Dashboard
                  courseDrawerShow={courseDrawerShow}
                  setCourseDrawerShow={setCourseDrawerShow}
                />
              </ProtectedRoute>
            }
          />

          <Route
            exact
            path="/dashboard/quiz"
            element={
              <ProtectedRoute>
                <DailyQuiz />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/profile"
            element={
              <ProtectedRoute>
                <EditProfile />
              </ProtectedRoute>
            }
          />

          <Route
            exact
            path="/dashboard/update-user-profile"
            element={
              <ProtectedRoute>
                <UpdateUserProfile />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/update-kyc-details"
            element={
              <ProtectedRoute>
                <UpdateKYCDetails />
              </ProtectedRoute>
            }
          />

          <Route
            exact
            path="/dashboard/lecture/:courseid?"
            element={
              <ProtectedRoute>
                <Lecture />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/personalized-lectures"
            element={
              <ProtectedRoute>
                <LectureLayout />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/lecture-notes"
            element={
              <ProtectedRoute>
                <LectureByNotesNew />
              </ProtectedRoute>
            }
          />

          <Route
            path="/dashboard/lecture/detail/:lectureId"
            element={
              <ProtectedRoute>
                <LectureVideo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/personalized-lecture/detail/:lectureId"
            element={
              <ProtectedRoute>
                <PersonalizedLectureVideo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/live-lecture/detail/:lectureId"
            element={
              <ProtectedRoute>
                <LiveLectureVideo />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dashboard/demand-lecture/detail/:sectionId/:lectureId"
            element={
              <ProtectedRoute>
                <OnDemandLectureDetail />
              </ProtectedRoute>
            }
          />


          <Route
            exact
            path="/dashboard/test-series"
            element={
              <ProtectedRoute>
                <TestSeries />
              </ProtectedRoute>
            }
          />

          <Route
            exact
            path="/dashboard/test-series/detail/:testId"
            element={
              <ProtectedRoute>
                <TestPage />
              </ProtectedRoute>
            }
          />

          <Route
            exact
            path="/dashboard/test-series/detail/:testId/test-overview"
            element={
              <ProtectedRoute>
                <TestResultSummery />
              </ProtectedRoute>
            }
          />

          {/* Postal Course Documents */}

          <Route
            exact
            path="/dashboard/postal-folder-listing"
            element={
              <ProtectedRoute>
                <PostalFolderList />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/new-postal-folder-listing"
            element={
              <ProtectedRoute>
                <NewPostalFolderList />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/postal-folder-listing/:id/"
            element={
              <ProtectedRoute>
                <PostalCourseSubListing />
              </ProtectedRoute>
            }
          />
          <Route
            exact
            path="/dashboard/new-postal-folder-listing/:id/"
            element={
              <ProtectedRoute>
                <NewPostalFileListing />
              </ProtectedRoute>
            }
          />



          <Route exact path="/dashboard/report" element={<CourseReport />} />
          <Route
            exact
            path="/dashboard/re-upload-answer-sheet"
            element={<ReUploadAnswerSheet />}
          />
        </Route>

        <Route exact path="/" element={<WithoutHeader />}>
          <Route
            path="/dashboard/test-series/detail/:testId/test"
            element={<TestUnit />}
          />
        </Route>
      </Routes>
    </section>
  );
};
export default Routing;
